function createAction(name) {
  return `@@betaOptIn/${name}`;
}
export const CHANGE_OPT_IN_STATUS = createAction('CHANGE_OPT_IN_STATUS');
export const changeOptInStatus = (status, betaName) => ({
  type: CHANGE_OPT_IN_STATUS,
  payload: {
    status,
    name: betaName
  }
});